module.exports = __webpack_public_path__ + "static/img/503.52f52ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/503.png
// module id = 532
// module chunks = 3